import React, { useEffect, useState, Fragment } from 'react';
import { XIcon } from 'lucide-react';
type TopicKey = 'contacto' | 'privacidad' | 'terminos-uso' | 'terminos-compra' | 'avisos-legales';
type LegalContent = {
  label: string;
  title: string;
  body: React.ReactNode;
};
const YEAR = new Date().getFullYear();
const CONTENT: Record<TopicKey, LegalContent> = {
  contacto: {
    label: 'Contacto',
    title: 'Contacto',
    body: <>
        <p data-id="element-48">
          ¿Tienes preguntas sobre el programa, tu acceso o tu compra? Nuestro
          equipo está disponible para ayudarte.
        </p>
        <p data-id="element-49">
          Escríbenos por WhatsApp:{' '}
          <a href="https://wa.link/infocommerce" target="_blank" rel="noopener noreferrer" className="text-[#0e7490] underline font-semibold" data-id="element-50">
            wa.link/infocommerce
          </a>
        </p>
        <p data-id="element-51">
          Correo de soporte:{' '}
          <a href="mailto:soporte@truemarketer.com" className="text-[#0e7490] underline font-semibold" data-id="element-52">
            soporte@truemarketer.com
          </a>
        </p>
        <p className="text-[#64748b]" data-id="element-53">
          Respondemos normalmente en un plazo de 24 a 48 horas hábiles.
        </p>
      </>
  },
  privacidad: {
    label: 'Política de Privacidad',
    title: 'Política de Privacidad',
    body: <>
        <p data-id="element-54">
          En True Marketer LLC respetamos tu privacidad y nos comprometemos a
          proteger los datos personales que compartes con nosotros.
        </p>
        <p data-id="element-55">
          <b data-id="element-56">Información que recopilamos.</b> Recopilamos los datos que nos
          proporcionas al registrarte o comprar (nombre, correo electrónico y
          datos de pago procesados de forma segura por nuestros proveedores),
          así como información técnica básica de uso del sitio.
        </p>
        <p data-id="element-57">
          <b data-id="element-58">Cómo usamos tu información.</b> Utilizamos tus datos para procesar
          tu compra, darte acceso al programa, brindarte soporte y enviarte
          comunicaciones relacionadas con el producto. No vendemos tu
          información personal a terceros.
        </p>
        <p data-id="element-59">
          <b data-id="element-60">Tus derechos.</b> Puedes solicitar acceso, corrección o eliminación
          de tus datos en cualquier momento escribiendo a nuestro equipo de
          soporte.
        </p>
        <p className="text-[#64748b]" data-id="element-61">
          Última actualización: {YEAR}. © {YEAR} True Marketer LLC.
        </p>
      </>
  },
  'terminos-uso': {
    label: 'Términos de Uso',
    title: 'Términos de Uso',
    body: <>
        <p data-id="element-62">
          Al acceder y utilizar este sitio aceptas los presentes Términos de
          Uso. Si no estás de acuerdo, te pedimos que no utilices el sitio.
        </p>
        <p data-id="element-63">
          <b data-id="element-64">Uso del contenido.</b> Todo el material disponible en este sitio y
          en el programa es propiedad de True Marketer LLC y está protegido por
          las leyes de propiedad intelectual. No está permitido reproducir,
          distribuir ni revender el contenido sin autorización por escrito.
        </p>
        <p data-id="element-65">
          <b data-id="element-66">Naturaleza educativa.</b> El contenido es de carácter educativo. No
          constituye asesoría legal, financiera ni de inversión. Eres
          responsable de tus propias decisiones y resultados.
        </p>
        <p data-id="element-67">
          <b data-id="element-68">Disponibilidad.</b> Nos reservamos el derecho de modificar,
          suspender o discontinuar cualquier parte del sitio o del programa en
          cualquier momento.
        </p>
        <p className="text-[#64748b]" data-id="element-69">
          Última actualización: {YEAR}. © {YEAR} True Marketer LLC.
        </p>
      </>
  },
  'terminos-compra': {
    label: 'Términos de Compra',
    title: 'Términos de Compra',
    body: <>
        <p data-id="element-70">
          Estos Términos de Compra aplican a toda adquisición realizada a través
          de este sitio.
        </p>
        <p data-id="element-71">
          <b data-id="element-72">Pago.</b> Los pagos se procesan de forma segura a través de
          nuestros proveedores. Al completar tu compra autorizas el cargo
          correspondiente al método de pago seleccionado.
        </p>
        <p data-id="element-73">
          <b data-id="element-74">Acceso.</b> Una vez confirmado el pago, recibirás acceso al
          programa y a los bonos incluidos según la oferta vigente al momento de
          la compra.
        </p>
        <p data-id="element-75">
          <b data-id="element-76">Garantía de devolución.</b> Ofrecemos una garantía de devolución
          conforme a las condiciones indicadas en la página de oferta. Para
          solicitar un reembolso, contacta a nuestro equipo de soporte dentro
          del plazo establecido.
        </p>
        <p className="text-[#64748b]" data-id="element-77">
          Última actualización: {YEAR}. © {YEAR} True Marketer LLC.
        </p>
      </>
  },
  'avisos-legales': {
    label: 'Avisos Legales',
    title: 'Avisos Legales',
    body: <>
        <p data-id="element-78">
          En True Marketer LLC creemos que el éxito es resultado del trabajo, la
          educación y la persistencia.
        </p>
        <p data-id="element-79">
          Los ejemplos y resultados mostrados no deben considerarse típicos y no
          representan una garantía de resultados. Tus resultados dependerán de
          tu esfuerzo, experiencia y ejecución.
        </p>
        <p data-id="element-80">
          La información de este sitio es de naturaleza educativa y no
          constituye asesoría legal ni financiera. Al usar este sitio aceptas la
          responsabilidad total de tus propios resultados.
        </p>
        <p data-id="element-81">
          Este sitio no está afiliado, patrocinado ni respaldado por Meta,
          Facebook ni por ninguna otra plataforma de terceros.
        </p>
        <p className="text-[#64748b]" data-id="element-82">
          <b className="text-[#0f172a]" data-id="element-83">True Marketer LLC</b> — © {YEAR} True
          Marketer LLC. Todos los derechos reservados.
        </p>
      </>
  }
};
const ORDER: TopicKey[] = ['privacidad', 'terminos-uso', 'terminos-compra', 'avisos-legales'];
type LegalLinksProps = {
  containerClassName?: string;
  linkClassName?: string;
};
export function LegalLinks({
  containerClassName = '',
  linkClassName = ''
}: LegalLinksProps) {
  const [active, setActive] = useState<TopicKey | null>(null);
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActive(null);
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [active]);
  const current = active ? CONTENT[active] : null;
  return <>
      <div className={containerClassName} data-id="element-84">
        {ORDER.map((key, i) => <Fragment key={key} data-id="element-85">
            {i > 0 && <span aria-hidden="true" data-id="element-86">|</span>}
            <button type="button" onClick={() => setActive(key)} className={linkClassName} data-id="element-87">
              {CONTENT[key].label}
            </button>
          </Fragment>)}
      </div>

      {current && <div role="dialog" aria-modal="true" aria-label={current.title} className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-88">
          <div className="absolute inset-0 bg-black/60" onClick={() => setActive(null)} data-id="element-89" />
          <div className="relative w-full max-w-[640px] max-h-[85vh] flex flex-col bg-white rounded-2xl shadow-2xl overflow-hidden text-left" data-id="element-90">
            <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-[#e2e8f0]" data-id="element-91">
              <h2 className="text-[18px] sm:text-[20px] font-extrabold text-[#0f172a]" data-id="element-92">
                {current.title}
              </h2>
              <button type="button" onClick={() => setActive(null)} aria-label="Cerrar" className="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-full text-[#64748b] hover:bg-[#f1f5f9] hover:text-[#0f172a] transition-colors" data-id="element-93">
                <XIcon className="w-5 h-5" data-id="element-94" />
              </button>
            </div>
            <div className="px-6 py-5 overflow-y-auto text-[14px] leading-relaxed text-[#334155] space-y-3.5" data-id="element-95">
              {current.body}
            </div>
          </div>
        </div>}
    </>;
}